import React from "react";
import { Icon } from "@iconify/react";
import { useClassRoom } from "../../Hooks/ClassRoom";

export default function StudentOffline({ handleClose }) {
  const { selectedUser } = useClassRoom();

  return (
    <div className="student-offline-box" role="alertdialog" aria-labelledby="student-offline-title" aria-describedby="student-offline-desc">
      <div className="student-offline-icon-wrap">
        <Icon
          icon="mdi:account-off-outline"
          className="student-offline-icon"
          aria-hidden="true"
        />
      </div>
      <h2 id="student-offline-title" className="student-offline-title">
        {selectedUser?.name} is offline
      </h2>
      <p id="student-offline-desc" className="student-offline-desc">
        They're not available right now. You can try again later or send a message—they'll see it when they're back.
      </p>
      <div className="student-offline-actions">
        <button
          type="button"
          className="student-offline-btn"
          onClick={handleClose}
          autoFocus
        >
          OK
        </button>
      </div>
    </div>
  );
}
